/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PatchedInpyVersion
 */
export interface PatchedInpyVersion {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  threediVersion?: string;
  /**
   *
   */
  threedicoreVersion?: string;
  /**
   *
   */
  readonly slug?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  active?: boolean;
}

/**
 * Check if a given object implements the PatchedInpyVersion interface.
 */
export function instanceOfPatchedInpyVersion(value: object): value is PatchedInpyVersion {
  return true;
}

export function PatchedInpyVersionFromJSON(json: any): PatchedInpyVersion {
  return PatchedInpyVersionFromJSONTyped(json, false);
}

export function PatchedInpyVersionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedInpyVersion {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    threediVersion: json["threedi_version"] == null ? undefined : json["threedi_version"],
    threedicoreVersion:
      json["threedicore_version"] == null ? undefined : json["threedicore_version"],
    slug: json["slug"] == null ? undefined : json["slug"],
    id: json["id"] == null ? undefined : json["id"],
    active: json["active"] == null ? undefined : json["active"],
  };
}

export function PatchedInpyVersionToJSON(json: any): PatchedInpyVersion {
  return PatchedInpyVersionToJSONTyped(json, false);
}

export function PatchedInpyVersionToJSONTyped(
  value?: Omit<PatchedInpyVersion, "url" | "slug" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    threedi_version: value["threediVersion"],
    threedicore_version: value["threedicoreVersion"],
    active: value["active"],
  };
}
